/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plans_Free_FeaturesInputs */

const en_pricing_plans_free_features = /** @type {(inputs: Pricing_Plans_Free_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`["Up to 3 projects","1 GB storage","Basic analytics","Community support"]`)
};

const es_pricing_plans_free_features = /** @type {(inputs: Pricing_Plans_Free_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`["Hasta 3 proyectos","1 GB de almacenamiento","Analiticas basicas","Soporte comunitario"]`)
};

/**
* | output |
* | --- |
* | "[\"Up to 3 projects\",\"1 GB storage\",\"Basic analytics\",\"Community support\"]" |
*
* @param {Pricing_Plans_Free_FeaturesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_plans_free_features = /** @type {((inputs?: Pricing_Plans_Free_FeaturesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plans_Free_FeaturesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_plans_free_features(inputs)
	return es_pricing_plans_free_features(inputs)
});